import React, { Component } from 'react'

const hasPerformancePerCinemaFilter = WrappedComponent => {
    class HasPerformancePerCinemaFilter extends Component {
        constructor(props) {
            super(props)

            this.state = {
                activeCinema: null,
                clusterCinemaOption: null,
                clusterCinemaName: null,
                clusterCinemas: null,
                clusterCinemaPk: null,
                cinemas: null
            }
            
            this.setActiveCinema = this.setActiveCinema.bind(this)
        }
        
        componentDidMount() {
            if(pmkinoFrontVars.cliData) {
                this.setState({
                    activeCinema: pmkinoFrontVars.cliData.currentCinemaId ? pmkinoFrontVars.cliData.currentCinemaId : null,
                    clusterCinemaOption: pmkinoFrontVars.cliData.clusterCinemaOption ? pmkinoFrontVars.cliData.clusterCinemaOption : false,
                    clusterCinemaName: pmkinoFrontVars.cliData.clusterCinemaName ? pmkinoFrontVars.cliData.clusterCinemaName : null,
                    clusterCinemas: pmkinoFrontVars.cliData.clusterCinemas ? pmkinoFrontVars.cliData.clusterCinemas : null,
                    currentCinemaPk: pmkinoFrontVars.cliData.currentCinemaId ? pmkinoFrontVars.cliData.currentCinemaId : null,
                    cinemas: pmkinoFrontVars.apiData.cinemas.items ? pmkinoFrontVars.apiData.cinemas.items : null
                })
            } else {
                this.setState({
                    activeCinema: null,
                    clusterCinemaOption: null,
                    clusterCinemaName: null,
                    clusterCinemas: null,
                    clusterCinemaPk: null,
                    cinemas: null
                })
            }
        }

        setActiveCinema(cinemaPk) {
            this.setState({
                activeCinema: cinemaPk
            })
        }

        render() {
            const {            
                clusterCinemaOption,
                activeCinema 
            } = this.props

            const injectedProps = {
                activeCinema: activeCinema ? activeCinema : this.state.activeCinema,
                clusterCinemaOption: clusterCinemaOption ? clusterCinemaOption : this.state.clusterCinemaOption,
                clusterCinemaName: this.state.clusterCinemaName,
                clusterCinemas: this.state.clusterCinemas,
                cinemas: this.state.cinemas,
                currentCinemaPk: this.state.currentCinemaPk,
                setActiveCinema: this.setActiveCinema
            }

            return <WrappedComponent
                {...this.props}
                {...injectedProps}
            />
        }
    }

    return HasPerformancePerCinemaFilter
}

export default hasPerformancePerCinemaFilter